// src/pages/Partners.jsx
import React from "react";
import { Container, Typography, Box } from "@mui/material";

export default function Partners() {
  return (
    <Container sx={{ py: 6 }}>
      <Typography variant="h3" sx={{ fontWeight: 600, mb: 2 }}>
        Partner Program
      </Typography>
      <Typography variant="body1" sx={{ color: "text.secondary" }}>
        We collaborate with energy developers, councils, auditors, IoT
        manufacturers, and carbon project developers.
      </Typography>

      <Box sx={{ mt: 4 }}>
        <Typography variant="h5" sx={{ mb: 1 }}>
          Why Partner with Carbon Bridge
        </Typography>
        <ul>
          <li>Verified carbon credit generation</li>
          <li>Device integration & telemetry</li>
          <li>Co-development of methodologies</li>
          <li>ESG & Net Zero alignment</li>
        </ul>
      </Box>
    </Container>
  );
}
